const MapStyles = {
    STANDALONE_MAP: "mapbox://styles/gacilu/ckhbytgud0z561apm5m6m3rzf",
    MAP_WITH_MARKERS: "mapbox://styles/gacilu/ckhbytgud0z561apm5m6m3rzf",
    SATELLITE: "mapbox://styles/mapbox/satellite-v9",
    VECTOR: "mapbox://styles/mapbox/streets-v11",
    STREET_SATELLITE: "mapbox://styles/mapbox/satellite-streets-v11",
    STREET_SATELLITE_Arabian_Gulf: "mapbox://styles/muditgoel3011/ckz006k1s003n15p19j3n1vea",
    VECTOR_Arabian_Gulf: "mapbox://styles/muditgoel3011/ckz03h336000515mgxarfc0as",
    darkTheme : "mapbox://styles/mapbox/dark-v11"
};

// Map type lookup for quick access
const mapTypeLookup = {
    sat: MapStyles.STREET_SATELLITE_Arabian_Gulf,
    streetSat: MapStyles.STREET_SATELLITE_Arabian_Gulf,
    vector: MapStyles.VECTOR_Arabian_Gulf,
    dark: MapStyles.darkTheme,
};

export const getMapStyle = (mapType) => mapTypeLookup[mapType] || MapStyles.VECTOR_Arabian_Gulf;